import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';
import { distinctUntilChanged } from 'rxjs';
import { SnackBarService } from './snackbar.service';

@Injectable({
  providedIn: 'root',
})
export class WebSocketService {
    private socket: WebSocketSubject<any>;
    private messageQueue:{message:string, date:Date}[] = []

    constructor(private snackBarService:SnackBarService) {
      // Initialize the WebSocket connection
      this.socket = webSocket('wss://node-red.staging.smartlions.center:1880/ws/me/'+environment.websocketEndpointListener);
      this.socket.pipe(distinctUntilChanged()).subscribe(
        (message) => {

          const old = this.messageQueue.find(x => x.message == message.message)
          const now = new Date();
          const refreshDate = new Date(now.getTime() - 10 * 60000);
          if(!old || old.date < refreshDate){

            this.snackBarService.error(message.message, 10000);
            this.messageQueue.push({message: message.message, date: now});
          }
        },
        (error) => {
          // Handle WebSocket connection errors (if not handled within retryWhen)
          console.error('WebSocket error:', error);
        }
      );
    }

    getSocket() {
      return this.socket;
    }
  }
